import Popover from '@components/v2/ui/Popover/Popover';
import { memo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import useOrderBookStore from '../../../../stores/OrderBook/orderBook.store';
import useOrderBook from '../../hooks/useOrderBook';
import OrderActiveMenuContent from './OrderActiveMenuContent';

interface OrderActiveMenuContentWithPopoverProps {
  orderBookAnchorEl?: HTMLSpanElement | null;
}

const OrderActiveMenuContentWithPopover = ({
  orderBookAnchorEl,
}: OrderActiveMenuContentWithPopoverProps) => {
  'use no memo';

  const { closeOrderBook } = useOrderBook();
  const { orderBookState } = useOrderBookStore(
    useShallow((state) => ({
      orderBookState: state.orderBookState,
    })),
  );

  return (
    <Popover
      open={orderBookState}
      anchorEl={orderBookAnchorEl}
      onClose={closeOrderBook}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          sx: (theme) => ({
            width: 382,
            height: 'auto',
            display: 'flex',
            overflow: 'hidden',
            marginTop: 1,
            borderRadius: `${theme.shape.borderRadius2xl}px`,
            border: `1px solid ${theme.palette.custom.border.primary}`,
          }),
        },
      }}
    >
      <OrderActiveMenuContent />
    </Popover>
  );
};

export default memo(OrderActiveMenuContentWithPopover);
